module.exports = __webpack_public_path__ + "static/agatawork5-bdf0029f7d8760848d0f23646288e1c6.jpg";